import AssetPlanItemsDataGrid from './AssetPlanItemsDataGrid';

export default AssetPlanItemsDataGrid;